class MainNav {
  constructor(el) {
    this.el = el;
    this.ui = {
      togglers: this.el.querySelectorAll('.js-nav-toggler'),
      targets: this.el.querySelectorAll('.js-nav-target'),
      themeItems: this.el.querySelectorAll('.js-nav-themeItem'),
      subTogglers: document.querySelectorAll('.js-nav-subToggler'),
      subTargets: document.querySelectorAll('.js-nav-subTarget'),
    };
    this.cssState = {
      active: 'is-active',
      open: 'is-open',
      section: 'is-section',
      theme: 'is-theme',
    };
    this.isMobile = window.matchMedia('(max-width: 784px)').matches;
    this.headerParentId = this.el.dataset.parentId;
    this.openCurrentSectionMobile();
    window.matchMedia('(max-width: 784px)').addEventListener('change', e => {
      this.isMobile = e.matches;
      this.handleMediaQueryChange();
    });
    this.ui.togglers.forEach(toggler =>
      toggler.addEventListener('click', this.handleTogglerClick.bind(this))
    );
    this.ui.subTogglers.forEach(toggler =>
      toggler.addEventListener('click', this.handleSubTogglerClick.bind(this))
    );

    // Custom event listener replacement for eventEmitter
    document.addEventListener(
      'header.closing',
      this.handleHeaderClosing.bind(this)
    );
  }

  handleTogglerClick(e) {
    e.preventDefault();
    const el = e.currentTarget;
    if (el.classList.contains(this.cssState.active)) {
      this.closeTarget(el);
      if (!this.isMobile) {
        // Dispatch custom event
        const closeEvent = new CustomEvent('header.close', {
          detail: this.headerParentId,
        });
        document.dispatchEvent(closeEvent);
      }
    } else {
      this.openTarget(el, 'main');
      if (!this.isMobile) {
        // Dispatch custom events
        const openEvent = new CustomEvent('header.open', {
          detail: this.headerParentId,
        });
        document.dispatchEvent(openEvent);

        const closeSubTargetEvent = new CustomEvent('header.closeSubTarget', {
          detail: el.dataset.target,
        });
        document.dispatchEvent(closeSubTargetEvent);
      }
    }
  }

  handleSubTogglerClick(e) {
    e.preventDefault();
    const el = e.currentTarget;
    if (el.classList.contains(this.cssState.active)) {
      this.closeTarget(el);
    } else {
      this.openTarget(el, 'sub');
    }
  }

  closeTarget(toggler) {
    const target = document.querySelector(toggler.dataset.target);
    toggler.classList.remove(this.cssState.active);
    target.classList.remove(this.cssState.open);
    this.ui.themeItems.forEach(item =>
      item.classList.remove(this.cssState.theme)
    );
  }

  openTarget(toggler, type) {
    const target = document.querySelector(toggler.dataset.target);
    if (toggler.dataset.theme) {
      this.ui.themeItems.forEach(item =>
        item.classList.add(this.cssState.theme)
      );
    } else {
      this.ui.themeItems.forEach(item =>
        item.classList.remove(this.cssState.theme)
      );
    }
    switch (type) {
      case 'main':
        this.ui.togglers.forEach(toggler =>
          toggler.classList.remove(this.cssState.active)
        );
        this.ui.targets.forEach(target =>
          target.classList.remove(this.cssState.open)
        );
        break;
      case 'sub':
        this.ui.subTogglers.forEach(toggler =>
          toggler.classList.remove(this.cssState.active)
        );
        this.ui.subTargets.forEach(target =>
          target.classList.remove(this.cssState.open)
        );
    }
    toggler.classList.add(this.cssState.active);
    target.classList.add(this.cssState.open);
  }

  handleHeaderClosing(e) {
    if (e.detail === this.headerParentId && !this.isMobile) {
      this.ui.togglers.forEach(toggler =>
        toggler.classList.remove(this.cssState.active)
      );
      this.ui.targets.forEach(target =>
        target.classList.remove(this.cssState.open)
      );
    }
  }

  handleMediaQueryChange() {
    if (!this.isMobile) {
      // Dispatch custom event
      const closeEvent = new CustomEvent('header.close', {
        detail: this.headerParentId,
      });
      document.dispatchEvent(closeEvent);
    }
  }

  openCurrentSectionMobile() {
    if (this.isMobile) {
      const currentToggler = Array.from(this.ui.togglers).find(
        toggler => toggler.dataset.section === 'true'
      );
      if (currentToggler) {
        this.openTarget(currentToggler, 'main');
      }
    }
  }
}
export default MainNav;
